import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NatureIcon(props: IconProps) {
    return <Icon {...props} iconKey={"nature"}/>
}
